import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64b94cde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overview" }
const _hoisted_2 = { class: "overview_top" }
const _hoisted_3 = { class: "overview_top_left space_between" }
const _hoisted_4 = { class: "overview_top_account align_center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "account_type flex" }
const _hoisted_7 = { class: "account_type_shadow" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "account_type align_center" }
const _hoisted_10 = { class: "overview_top_balance" }
const _hoisted_11 = { class: "space_between" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "可用余额", -1))
const _hoisted_13 = { class: "balance" }
const _hoisted_14 = { class: "money" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overview_top_line" }, null, -1))
const _hoisted_16 = { class: "overview_top_right" }
const _hoisted_17 = { class: "space_between" }
const _hoisted_18 = { class: "yesterday" }
const _hoisted_19 = { class: "overview_scroll" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "doughnut_echar_bottom" }
const _hoisted_22 = { class: "doughnut_left" }
const _hoisted_23 = { class: "doughnut_left_title align_center" }
const _hoisted_24 = { class: "doughnut_left_title doughnut_left_end align_center" }
const _hoisted_25 = { class: "align_center" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mod_nav_btn_title" }, "购买", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mod_nav_btn_title" }, "购买", -1))
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["id"]
const _hoisted_30 = { class: "details" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details_line" }, null, -1))
const _hoisted_32 = { class: "mod_c_title" }
const _hoisted_33 = { class: "details_more" }
const _hoisted_34 = {
  key: 0,
  class: "details_more_btn color_blue"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = ["id"]
const _hoisted_37 = { style: {"color":"rgb(237, 158, 0)"} }
const _hoisted_38 = { class: "drawer" }
const _hoisted_39 = { class: "drawer_top flex" }
const _hoisted_40 = {
  key: 0,
  class: "drawer_top_title"
}
const _hoisted_41 = { class: "drawer_top_num" }
const _hoisted_42 = {
  key: 1,
  class: "drawer_top_title"
}
const _hoisted_43 = { class: "drawer_top_num" }
const _hoisted_44 = { class: "buy_box" }
const _hoisted_45 = { class: "buy_content align_center" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "buy_message flex" }
const _hoisted_48 = { class: "name" }
const _hoisted_49 = { class: "mobile" }

import CDelModal from '@/components/CDelModal.vue';
import { computed, nextTick, onMounted, onUnmounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { QuestionCircleFilled, CaretUpOutlined } from '@ant-design/icons-vue';
import http from '@/api/resource';
import axios from '@/api/account';
import user from '@/api/user';
import * as echarts from 'echarts';
import { Table, message, Pagination, Popover, DatePicker, Drawer, Tooltip, Modal } from 'ant-design-vue';
import AppLink from '@/components/AppLink.vue';
import { emptyDataSec } from '@/assets';
import { getRoleIcon } from '@/utils/common';
import { useDebounce } from '@/hooks/useDebounce';
import moment, { Moment } from 'moment';
import CLoading from '@/components/CLoading.vue';
import { useHomeStore } from '@/pinia/home';

interface overviewType {
  account_version: string;
  income_amount: number;
  account_balance: string;
  yesterday_earning: number | 0;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OldSummary',
  setup(__props) {

const aPopover = Popover;
const aTooltip = Tooltip;
const aTable = Table;
const aModal = Modal;
const aPagination = Pagination;
const aDatePicker = DatePicker;
const aDrawer = Drawer;
const homeStore = useHomeStore();
const store = useStore();
const userData = computed(() => store.state.user.userInfo);
const visible = ref(false);
// 账户安全等级
const grade = ref();
const buildInfo = () => {
  user.buildInfo().then((res) => {
    let data = res.data.data;
    grade.value = data.grade;
  });
};
buildInfo();

//获取专属客户
const BuyVisible = ref(false);
const avatarUrl = ref('');
const buyMobile = ref();
const buyName = ref();
const emptClick = () => {
  BuyVisible.value = true;
  http.getAccountManagerInfo().then((res) => {
    const data = res.data.data;
    avatarUrl.value = data.avatar_url;
    buyMobile.value = data.mobile;
    buyName.value = data.name;
  });
};
const purchaseClick = () => {
  BuyVisible.value = false;
};

// 获取数据，刷新
const overviewData = ref<overviewType | any>();
let echarsList: any = ref([]);
const toll_mode = ref(0);
const iconPath = ref('');
// const package_index = ref();
const packageIndex = ref(0);
const subAccount = ref(0); // 0主账号，1子账号
const getAccountInfo = useDebounce(() => {
  http.allAccountInfo().then((res) => {
    const data = res.data.data;
    overviewData.value = data;
    iconPath.value = getRoleIcon(data.role_id);
    toll_mode.value = data.toll_mode; //toll_mode 收费模式 0.并发 1.观看时长
    echarsList.value = [...data.pack];
    toll_mode.value == 0 ? getConcurrentList() : getBill(echarsList.value[0].service_type);
    packageIndex.value = echarsList.value[0].package_index;
    subAccount.value = data.sub_account;
    echarsList.value.map((res: any, index: number) => {
      res.resource_package.map((item: any) => {
        item.status = item.status == 0 ? '正常' : item.status == 1 ? '使用完' : item.status == 2 ? '已过期' : '未生效';
      });
      nextTick(() => {
        const pieChartsId = document.getElementById(pieEchars.value + index) as HTMLElement;
        const pieChartsSet = echarts.init(pieChartsId);
        getSetOption(res) && pieChartsSet.setOption(getSetOption(res));
      });
    });
  });
});
getAccountInfo();

// 转到余额
const balanceModal = ref(false);
const openDelModal = () => {
  balanceModal.value = !balanceModal.value;
};
const openBalanceModal = () => {
  overviewData.value.income_amount > 0 ? (balanceModal.value = true) : '';
};
const transferBalance = () => {
  message.destroy();
  const income_amount = (overviewData.value as any).income_amount;
  if (Number(income_amount) == 0) {
    message.error('转入金额不能为空');
    balanceModal.value = false;
  } else {
    const data = {
      amount: income_amount,
    };
    http
      .transferInBalance(data)
      .then((res) => {
        message.success(res.data.message);
        getAccountInfo();
      })
      .finally(() => {
        balanceModal.value = false;
      });
  }
};

// 环形图
const pieEchars = ref(`pieChart${Date.now() + Math.random()}`);
const getSetOption = (res: any) => {
  const data = [
    {
      value: res.used,
      itemStyle: {
        color:
          res.balance_status == 0 || res.balance_status == '暂无资源包'
            ? '#00CCB0'
            : res.balance_status == 1
            ? '#FAAD14'
            : '#FF4D4F',
      },
      name: '使用',
    },
    {
      value: res.balance,
      itemStyle: {
        color: '#F0F2F5',
      },
      emphasis: {
        itemStyle: {
          color: '#F0F2F5',
        },
      },
      name: '剩余',
    },
  ];
  res.used == 0 ? data.splice(0, 1) : '';
  const setOption = {
    title: {
      text: res.total + res.company,
      x: 'center',
      y: 'center',
      textStyle: {
        fontSize: '10',
        color: '#9AA1A9',
      },
    },
    tooltip: {
      //不能删
      // trigger: '并发数',
    },
    legend: {
      show: false, //隐藏名称
    },
    series: [
      {
        type: 'pie',
        radius: ['60%', '90%'],
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        data: data,
      },
    ],
  };
  return setOption;
};

// 获取折线图数据
const currentList: any = ref([]);
const currentDate: any = ref([]);
const currentSum: any = ref([]);
const lineEchars: any = ref(`lineEchars${Date.now() + Math.random()}`);
let lineEcharSet: any;
const lineDate = ref();
const getConcurrentList = useDebounce(() => {
  message.destroy();
  const data = {
    start_at: lineDate.value ? moment(lineDate.value).format('YYYY-MM-DD') : '',
  };
  http
    .concurrentList({ params: data })
    .then((res) => {
      currentList.value = [];
      currentDate.value = [];
      currentSum.value = [];
      currentList.value = res.data.data;
      Object.keys(currentList.value).map((res: any) => {
        currentDate.value.push(currentList.value[res]['date']);
        currentSum.value.push(currentList.value[res]['sum']);
      });
      nextTick(() => {
        if (currentList.value.length > 0 && packageIndex.value == 1) {
          const lineEcharId = document.getElementById(lineEchars.value) as HTMLElement;
          lineEcharSet = echarts.init(lineEcharId);
          getLineOption() && lineEcharSet.setOption(getLineOption());
        }
      });
    })
    .finally(() => {
      message.destroy();
      showLoading.value = true;
    });
});

const disabledDate = (current: Moment) => {
  return current > moment().endOf('day');
};

// 折线图
const getLineOption = () => {
  const setOption = {
    tooltip: {
      trigger: 'axis',
      position: function (pt: any) {
        return [pt[0], '10%'];
      },
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: currentDate.value,
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed',
        },
      },
    },
    series: [
      {
        name: '在线人数：',
        type: 'line',
        symbol: 'none',
        sampling: 'lttb',
        itemStyle: {
          color: 'rgba(0, 204, 176, 1)',
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(0, 204, 176, 1)',
            },
            {
              offset: 1,
              color: 'rgba(0, 204, 176, 0)',
            },
          ]),
        },
        data: currentSum.value,
        smooth: true,
      },
    ],
  };
  return setOption;
};

// 环形图点击左右滚动
const doughnut = ref(null);
const scrollLeft = ref(0);
const toRight = (type: number) => {
  let width: any = document.getElementsByClassName('overview_doughnut')[0];
  width = width.offsetWidth * 0.25;
  type == 1 ? ((doughnut.value as any).scrollLeft += width) : ((doughnut.value as any).scrollLeft -= width);
  scrollLeft.value = (doughnut.value as any).scrollLeft;
};

// 环形图切换
const getDetailed = (index: number, serviceType: number) => {
  packageIndex.value = index;
  if (index == 1 && toll_mode.value == 0) {
    getConcurrentList(); //并发
  } else if (index == 4) {
    getMediaBill(); //媒体库
  } else {
    getBill(serviceType);
  }
};

// 表格标题
const columns = [
  {
    title: '账单编号',
    dataIndex: 'id',
    fixed: 'left',
    align: 'center',
    key: '0',
  },
  {
    title: '频道名称',
    dataIndex: 'studio_title',
    key: '1',
    align: 'left',
    ellipsis: true,
    slots: {
      customRender: 'studio_title',
    },
  },
  {
    title: '服务类型',
    dataIndex: 'type_name',
    key: '2',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '支付方式',
    dataIndex: 'remarke',
    key: '3',
    ellipsis: true,
    align: 'left',
  },
  {
    title: '消费',
    dataIndex: 'number',
    key: '4',
    align: 'center',
    slots: {
      customRender: 'number',
    },
  },
  {
    title: '支付时间',
    dataIndex: 'created_at',
    key: '5',
    align: 'center',
  },
  {
    title: '备注',
    key: '6',
    dataIndex: 'tips',
    align: 'left',
    ellipsis: true,
    fixed: 'right',
  },
];

// 媒体库表格标题
const mediaColumns = [
  {
    title: '文件名称',
    dataIndex: 'title',
    align: 'left',
    key: '0',
    ellipsis: true,
  },
  {
    title: '文件类型',
    dataIndex: 'type',
    align: 'center',
    key: '1',
  },
  {
    title: ' 文件大小',
    dataIndex: 'size_stand',
    align: 'center',
    key: '2',
  },
  {
    title: ' 上传时间',
    dataIndex: 'created_at',
    align: 'center',
    key: '3',
  },
];

const showLoading = ref<boolean>(false);
// 抽屉表格
const detailsColumns = [
  {
    title: '资源名称',
    dataIndex: 'name',
    align: 'left',
    key: '0',
    ellipsis: true,
  },
  {
    title: '规格',
    dataIndex: 'origin_number',
    align: 'center',
    key: '1',
  },
  {
    title: '余额',
    dataIndex: 'number',
    align: 'center',
    key: '2',
  },
  {
    title: '生效时间',
    dataIndex: 'start_at',
    align: 'center',
    key: '3',
  },
  {
    title: '到期时间',
    dataIndex: 'end_at',
    align: 'center',
    key: '4',
  },
  {
    title: '状态',
    dataIndex: 'status',
    align: 'center',
    key: '5',
  },
];

// 获取表格数据
const resourceData: any = ref([]);
const getBill = useDebounce((id: number) => {
  let resource: any = {
    type: id,
    page: 1,
    page_num: 5,
  };
  showLoading.value = false;
  axios
    .getEstimatedFeeBillList({ params: resource })
    .then((res) => {
      resourceData.value = [...res.data.data.data];
    })
    .finally(() => {
      showLoading.value = true;
    });
});

// 媒体库表格数据
const mediaData: any = ref([]);
// 分页器
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 5, // 每页条数
  totalSize: 0, // 总页数
  options: ['5', '10', '20', '30', '40'], // 选项
});
const getMediaBill = () => {
  const billData = {
    type: '',
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
  };
  showLoading.value = false;
  http
    .mediaBill({ params: billData })
    .then((res) => {
      const data = res.data.data;
      data.data.map((res: any) => {
        res['type'] = res['type'] == 0 ? ' 文档' : '视频';
      });
      mediaData.value = [...data.data];
      pageConfig.totalSize = data.total;
    })
    .finally(() => {
      message.destroy();
      showLoading.value = true;
    });
};

const detailsData: any = ref([]);
const basic_resources: any = ref([]);
const openDrawer = (index: number) => {
  visible.value = true;
  detailsData.value = [...echarsList.value[index].resource_package];
  basic_resources.value = [...echarsList.value[index].basic_resources];
};

onMounted(() => {
  window.onresize = () => {
    if (packageIndex.value == 1 && currentList.value.length > 0) {
      lineEcharSet.resize();
    }
  };
});
onUnmounted(() => {
  window.onresize = null;
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "account_avatar",
              src: _unref(userData).avatar,
              alt: ""
            }, null, 8, _hoisted_5),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, "账户类型：" + _toDisplayString(overviewData.value?.account_version), 1),
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("img", {
                    src: iconPath.value,
                    alt: ""
                  }, null, 8, _hoisted_8), [
                    [_vShow, iconPath.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, "账户安全等级：" + _toDisplayString(grade.value), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", {
                class: "button color_blue",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(getAccountInfo) && _unref(getAccountInfo)(...args)))
              }, "刷新")
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(overviewData.value?.account_balance) + "元", 1),
              (subAccount.value == 0 && _unref(homeStore).funcData?.WalletRecharge)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/wallet/recharge"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        class: "button",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("充值")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", null, "收益余额：" + _toDisplayString(overviewData.value?.income_amount) + "元", 1),
            _createElementVNode("div", {
              class: _normalizeClass(overviewData.value?.income_amount > 0 ? 'color_blue' : 'color_base'),
              onClick: openBalanceModal
            }, "转到余额", 2)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createTextVNode(" 昨日收益：" + _toDisplayString(overviewData.value?.yesterday_earning) + "元 ", 1),
            (Number(overviewData.value?.yesterday_earning) > 0)
              ? (_openBlock(), _createBlock(_unref(CaretUpOutlined), {
                  key: 0,
                  class: "yesterday_icon"
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", {
          class: "overview_doughnut",
          ref_key: "doughnut",
          ref: doughnut
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(echarsList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "doughnut_echar",
              key: index,
              onClick: ($event: any) => (getDetailed(item.package_index, item.service_type))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(item.package_index == packageIndex.value ? 'doughnut_left_name_click' : 'doughnut_left_name')
              }, _toDisplayString(item.name), 3),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createTextVNode(" 到期时间： "),
                    _createVNode(_unref(aPopover), {
                      placement: "right",
                      class: "switch_tips"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", null, "版本到期时间：" + _toDisplayString(item.end_at ? item.end_at : '永久有效'), 1),
                        _createElementVNode("div", null, "资源包到期时间：" + _toDisplayString(item.resource_pack_end_at ? item.resource_pack_end_at : '暂无资源包'), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(QuestionCircleFilled), {
                          style: _normalizeStyle({
                      color:
                        item.time_status == 0 || item.time_status == '暂无资源包'
                          ? '#00CCB0'
                          : item.time_status == 1
                          ? '#FAAD14'
                          : '#FF4D4F',
                    }),
                          class: "QuestionCircleFilled"
                        }, null, 8, ["style"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createTextVNode(" 余额状态： "),
                    _createVNode(_unref(aPopover), {
                      placement: "right",
                      class: "switch_tips"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", null, "版本余额：" + _toDisplayString(item.base_balance) + _toDisplayString(item.company), 1),
                        _createElementVNode("div", null, "资源包余额：" + _toDisplayString(item.resource_pack_balance) + _toDisplayString(item.company), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(QuestionCircleFilled), {
                          style: _normalizeStyle({
                      color:
                        item.balance_status == 0 || item.balance_status == '暂无资源包'
                          ? '#00CCB0'
                          : item.balance_status == 1
                          ? '#FAAD14'
                          : '#FF4D4F',
                    }),
                          class: "QuestionCircleFilled"
                        }, null, 8, ["style"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    (
                    (item.package_index == 1 && _unref(homeStore).funcData?.ResourcePurchase) ||
                    (item.package_index == 11 && _unref(homeStore).funcData?.ResourcePurchase) ||
                    (item.package_index == 6 && _unref(homeStore).funcData?.ResourcePurchase)
                  )
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          class: "align_center mod_btn_primary actived",
                          size: "small",
                          onClick: emptClick
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_svg_icon, {
                              class: "mod_nav_btn_icon",
                              "icon-class": "purchase"
                            })
                          ]),
                          default: _withCtx(() => [
                            _hoisted_26
                          ]),
                          _: 1
                        }))
                      : (subAccount.value == 0 && _unref(homeStore).funcData?.ResourcePurchase)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: { path: '/wallet/resource', query: { pageIndex: item.package_index } }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                class: "align_center mod_btn_primary actived",
                                size: "small"
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_svg_icon, {
                                    class: "mod_nav_btn_icon",
                                    "icon-class": "purchase"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _hoisted_27
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "doughnut_left_details color_blue",
                      style: _normalizeStyle({ margin: subAccount.value == 0 ? '' : '0' }),
                      onClick: _withModifiers(($event: any) => (openDrawer(index)), ["stop"])
                    }, " 详情 ", 12, _hoisted_28)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "doughnut_canvas",
                  id: pieEchars.value + index
                }, null, 8, _hoisted_29)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(item.package_index == packageIndex.value ? 'doughnut_echar_click' : '')
              }, null, 2)
            ], 8, _hoisted_20))
          }), 128))
        ], 512)
      ]),
      _createVNode(CDelModal, {
        visible: balanceModal.value,
        centered: "",
        close: openDelModal,
        ok: transferBalance
      }, {
        title: _withCtx(() => [
          _createTextVNode("此操作将收益余额转到余额，是否确定？")
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, [
        _createTextVNode(" 资源明细 "),
        _createElementVNode("div", _hoisted_33, [
          (packageIndex.value == 1)
            ? (_openBlock(), _createBlock(_unref(aDatePicker), {
                key: 0,
                format: "YYYY-MM-DD",
                onChange: _unref(getConcurrentList),
                value: lineDate.value,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((lineDate).value = $event)),
                class: "mod_range_picker details_more_btn",
                "disabled-date": disabledDate
              }, {
                suffixIcon: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
                ]),
                _: 1
              }, 8, ["onChange", "value"]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, { to: { path: '/wallet/bill', query: { bill: true } } }, {
            default: _withCtx(() => [
              (packageIndex.value !== 1 && packageIndex.value !== 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, "更多>>"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      (packageIndex.value == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            (!showLoading.value)
              ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
              : _createCommentVNode("", true),
            (currentList.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "details_echars",
                  id: lineEchars.value
                }, null, 8, _hoisted_36))
              : _createCommentVNode("", true),
            (currentList.value.length == 0 && showLoading.value)
              ? (_openBlock(), _createBlock(_component_a_empty, {
                  key: 2,
                  class: "empty_wrap",
                  image: _unref(emptyDataSec),
                  description: "页面暂无数据信息~"
                }, null, 8, ["image"]))
              : _createCommentVNode("", true)
          ]))
        : (packageIndex.value == 4)
          ? (_openBlock(), _createBlock(_unref(aTable), {
              key: 1,
              loading: !showLoading.value,
              columns: mediaColumns,
              "data-source": mediaData.value,
              pagination: false,
              class: "details_table",
              bordered: "",
              rowKey: (record, index) => index
            }, null, 8, ["loading", "data-source", "rowKey"]))
          : (_openBlock(), _createBlock(_unref(aTable), {
              key: 2,
              loading: !showLoading.value,
              columns: columns,
              "data-source": resourceData.value,
              class: "details_table",
              pagination: false,
              bordered: "",
              rowKey: (record) => record.id
            }, {
              studio_title: _withCtx(({ record }) => [
                _createVNode(AppLink, {
                  class: "coustom_link",
                  to: `/live_set/${record.studio_id}/broad_cast_control`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(record.studio_title), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              number: _withCtx(({ record }) => [
                _createElementVNode("a", _hoisted_37, _toDisplayString(record.number), 1)
              ]),
              _: 1
            }, 8, ["loading", "data-source", "rowKey"])),
      (packageIndex.value == 4 && mediaData.value.length > 0)
        ? (_openBlock(), _createBlock(_unref(aPagination), {
            key: 3,
            class: "details_pagination",
            "show-quick-jumper": "",
            "show-size-changer": "",
            "show-less-items": "",
            current: pageConfig.current,
            "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig.current) = $event)),
            "page-size": pageConfig.pageSize,
            "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageConfig.pageSize) = $event)),
            total: pageConfig.totalSize,
            pageSizeOptions: pageConfig.options,
            onChange: getMediaBill,
            onShowSizeChange: getMediaBill
          }, null, 8, ["current", "page-size", "total", "pageSizeOptions"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(aDrawer), {
        title: "资源详情",
        placement: "right",
        closable: true,
        visible: visible.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
        width: "50%"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              (basic_resources.value[0])
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(basic_resources.value[0]?.name) + "：", 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_41, _toDisplayString(basic_resources.value[0]?.number), 1),
              (basic_resources.value[1])
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(basic_resources.value[1]?.name) + "：", 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_43, _toDisplayString(basic_resources.value[1]?.number), 1)
            ]),
            _createVNode(_unref(aTable), {
              columns: detailsColumns,
              "data-source": detailsData.value,
              pagination: false,
              class: "details_table",
              bordered: "",
              rowKey: (record, index) => index
            }, null, 8, ["data-source", "rowKey"])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createVNode(_unref(aModal), {
      centered: "",
      visible: BuyVisible.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((BuyVisible).value = $event)),
      title: "我的专属顾问",
      "cancel-button-props": { style: { display: 'none' } },
      onOk: purchaseClick
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _withDirectives(_createElementVNode("img", {
              src: avatarUrl.value,
              alt: ""
            }, null, 8, _hoisted_46), [
              [_vShow, avatarUrl.value]
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("span", _hoisted_48, _toDisplayString(buyName.value), 1),
              _createElementVNode("span", _hoisted_49, _toDisplayString(buyMobile.value), 1)
            ])
          ]),
          _createVNode(_component_a_button, {
            href: "https://www13.53kf.com/webCompany.php?arg=10561881&kf_sign=Tc2NjMTY2MM3OTY4MzgwOTczMDAxMzcyNTYxODgx&style=1",
            target: "_blank",
            class: "message_btn",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("在线交谈")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})